import { render, staticRenderFns } from "./SimpleFileUpload.vue?vue&type=template&id=48448f6e&"
import script from "./SimpleFileUpload.vue?vue&type=script&lang=js&"
export * from "./SimpleFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFileUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports